module.exports = __webpack_public_path__ + "static/img/HT3-max.669623e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/refs/ht/HT3-max.jpg
// module id = p8MP
// module chunks = 0